import {Component, Input, OnInit} from "@angular/core";
import {PagerDataObject} from "../../entities/pagerDataObject";
import {Subject} from "rxjs";
import {SharedService} from "../../services/sharedService";
import {switchMap} from "rxjs/operators";
import {Service} from "../../entities/service";
import {ExternalApiGatewayService} from "../../services/external-api-gateway.service";

@Component({
    selector: 'external-api-gateway-list',
    template: `
        <div style="position: relative; top: 0;left: 1%; width: 97%;">
            <h2>{{ 'SERVICE-API.TITLE' | translate }}</h2>
            <ntr-add-button [openView]="'ext-api/add'"></ntr-add-button>

            <ntr-datatable [data]="data" [metaInfo]="metaInfo" [entityTitle]="'Api Configuraiton'"
                           [modelView]="'ext-api'" [disableHeader]="false"
                           (onQuery)="onGridQuery($event)" [columns]="columns" [headers]="headers"
                           (onDeleteQuery)="deleteExtApi($event)"></ntr-datatable>
        </div>
    `
})
export class ExternalApiGatewayListComponent implements OnInit {

    metaInfo: string[];
    columns: Array<any>;
    data: PagerDataObject;
    @Input()
    headers = [' ', 'Name', 'URL'];
    @Input()
    disableHeader = false;
    subscription: any;
    private dataSub$ = new Subject<any>();
    query: String;

    ngOnInit(): void {

    }

    ngAfterViewInit(): void {
        this.sharedService.loadMenuItems('admin');
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    constructor(private service: ExternalApiGatewayService,
                private sharedService: SharedService) {
        this.subscription = this.dataSub$.pipe(switchMap(filter => {
            return this.service.paging$(filter);
        }))
            .subscribe(data => {
                this.data = data;
            });
        this.metaInfo = this.service.getMetaInfo();
        this.columns = this.service.getColumns();
    }

    onGridQuery(query) {
        this.query = query
        this.dataSub$.next(query);
    }

    deleteExtApi(id) {
        this.service.delete$(id)
            .subscribe(service => {
                this.dataSub$.next(this.query);
            });
    }

}

